import { request } from './request'
export function getlist(data) {
    return request({
        url: '/admin/subject/subject/getlist',
        method: 'POST',
        data
    })
}
export function TimestampToTime(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    return Y + M + D + h + m;
}
export function TimestampToTime_2(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '/';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    return Y + M + D ;
}
export function TimestampToTime_ss(timestamp) {
//    console.log(timestamp)
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m ,s;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()+':';
    s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
   
    return Y + M + D + h + m + s;
}
export function TimestampToTime_onlyday(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    return M + D ;
}
export function getLabeleFromId(arr, id) {
    for (let i in arr) {
        if (arr[i].id == id) {
            return arr[i].name
        }
    }

}
export function TimestampToTime_weeklyPlan(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    var week;     
    if(date.getDay() == 0) week = "周日"     
    if(date.getDay() == 1) week = "周一"     
    if(date.getDay() == 2) week = "周二"     
    if(date.getDay() == 3) week = "周三"     
    if(date.getDay() == 4) week = "周四"     
    if(date.getDay() == 5) week = "周五"     
    if(date.getDay() == 6) week = "周六"    
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    return Y + M + D + '    ' +  week;
}
export function TimestampToTime_weekday(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    var week;     
    if(date.getDay() == 0) week = "周日"     
    if(date.getDay() == 1) week = "周一"     
    if(date.getDay() == 2) week = "周二"     
    if(date.getDay() == 3) week = "周三"     
    if(date.getDay() == 4) week = "周四"     
    if(date.getDay() == 5) week = "周五"     
    if(date.getDay() == 6) week = "周六"    
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    // console.log(week)
    return  week;
}

export function TimestampToTime_weeklyPlan_endtime(timestamp) {
    // console.log(timestamp)
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y, M, D, h, m;
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    D = date.getDate() + ' ';
    h = date.getHours() + ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    var week;     
    if(date.getDay() == 0) week = "周日"     
    if(date.getDay() == 1) week = "周一"     
    if(date.getDay() == 2) week = "周二"     
    if(date.getDay() == 3) week = "周三"     
    if(date.getDay() == 4) week = "周四"     
    if(date.getDay() == 5) week = "周五"     
    if(date.getDay() == 6) week = "周六"    
    // m = date.getMinutes() + ':';
    // s = date.getSeconds();
    return  M + D  + h + m+ '    ' + '(' +week+')';
}
export function FormDataToJSon(formData) {
    console.log(formData)
    var objData = {};
    formData.forEach((value, key) =>{
        console.log(value)
        if(key =='content'){
            objData[key] =JSON.parse(value)
        }else{
            objData[key] = value
        }
        
    });
    console.log(objData)
    return objData;
};